'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$7() {
  this.aA7 = null;
  this.aA8 = false;
}
export { $c_Lpresto_AgentView$$anon$7 as $c_Lpresto_AgentView$$anon$7 };
$p = $c_Lpresto_AgentView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$7;
/** @constructor */
function $h_Lpresto_AgentView$$anon$7() {
}
export { $h_Lpresto_AgentView$$anon$7 as $h_Lpresto_AgentView$$anon$7 };
$h_Lpresto_AgentView$$anon$7.prototype = $p;
$p.bW = (function() {
  if ((!this.aA8)) {
    this.aA7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.aA8 = true;
  }
  return this.aA7;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_AgentView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$7, "presto.AgentView$$anon$7", ({
  Eb: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$7 as $d_Lpresto_AgentView$$anon$7 };
//# sourceMappingURL=presto.-Agent-View$$anon$7.js.map
